import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const ContentContext = createContext({ content: {}, loading: true });

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/content").then((r) => {
      setContent(r.data || {});
      if (r.data?.seo_title) document.title = r.data.seo_title;
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <ContentContext.Provider value={{ content, loading }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
